module.exports = __webpack_public_path__ + "static/media/Tanker.3e0121ab.svg";